<template>
  <div v-if="tag">
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <div class="row">
          <h1>Tag Management: {{tag.name}}</h1>
          <a @click="$router.go(-1)" class="btn btn-info" active-class="">
            <i class="fa fa-chevron-left"></i> Back
          </a>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="dashboard-block">
        <div class="row">
          <div class="panel panel-grey">
            <div class="panel-body">
              <h2>Children</h2>

              <tags v-if="tag.tag_type" :id="tag.id" :tagType="tag.tag_type" v-model="tag.child_tags"/>
            </div>
          </div>

          <ladda-button
            type="submit"
            class="btn btn-primary"
            :click="handleSaveTagsCallback">
            Save Changes
          </ladda-button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="dashboard-block">
        <div class="row">
          <div class="panel panel-grey">
            <div class="panel-body">
              <h2>PARENTS</h2>

              <tags v-if="tag.tag_type" :id="tag.id" :tagType="tag.tag_type" v-model="tag.parent_tags"/>
            </div>
          </div>

          <ladda-button
            type="submit"
            class="btn btn-primary"
            :click="handleSaveTagsCallback">
            Save Changes
          </ladda-button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="dashboard-block">
        <div class="row">
          <div class="panel panel-grey">
            <div class="panel-body">
              <h2>Synonyms</h2>
              <div class="row">
                <div class="col-xs-9">
                  <input name="alias" type="text" class="form-control input-sm" v-model="synonym"/>
                </div>
                <div class="col-xs-3">
                  <ladda-button
                    class="btn btn-success inactive"
                    :click="handleAddSynonymCallback">Add Synonym
                  </ladda-button>
                </div>
              </div>
              <ul class="talent-list">
                <li v-for="(synonym, index) in tag.synonyms" :key="index">
                  <div class="flex-row">
                    <div class="col-xs-9">
                      <p>{{ synonym }}</p>
                    </div>
                    <div class="col-xs-3">
                      <ladda-button
                        class="btn circle-btn btn-danger inactive"
                        :click="handleDeleteSynonymCallback"
                        :arguments="[index]">
                        <i class="fa fa-trash"></i> Delete Synonym
                      </ladda-button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="dashboard-block">
        <div class="row">
          <div class="panel panel-grey">
            <div class="panel-body">
              <h2>Translations</h2>
              <div class="row">
                <div class="col-xs-6">
                  <input name="alias" type="text" class="form-control input-sm" v-model="translation"/>
                </div>
                <div class="col-xs-3">
                  <selectize
                    ref="regions"
                    class="selectize selectize-single"
                    name="region"
                    v-model="region"
                    placeholder="Region"
                    :options="filteredRegionsOptions"/>
                </div>
                <div class="col-xs-3">
                  <ladda-button
                    class="btn btn-success inactive"
                    :click="handleAddTranslationCallback">Add Translation
                  </ladda-button>
                </div>
              </div>
              <ul class="talent-list">
                <li v-for="(translation, region) in tag.translations" :key="region">
                  <div class="flex-row">
                    <div class="col-xs-9">
                      {{ region }} - {{ translation }}
                    </div>
                    <div class="col-xs-3">
                      <ladda-button
                        class="btn circle-btn btn-danger inactive"
                        :click="() => { handleDeleteTranslationCallback(region) }">
                        <i class="fa fa-trash"></i> Delete Translation
                      </ladda-button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="dashboard-block">
        <h2>
          {{ $starLabelPlural | sentenceCase }}
          <a href="#" data-toggle="modal" data-target="#add-tag-talent" @click="toggleAddTalent">
            <button class="btn btn-primary pull-right m-t-h2-btn">
              <i class="fa fa-fw fa-plus"></i> Add {{ $starLabelPlural | sentenceCase }}
            </button>
          </a>
        </h2>
        <pickstar-loading v-if="fetching" class="m-lg"/>
        <div v-if="!fetchingTags">
          <ul v-if="!fetching && tagTalent && tagTalent.length" class="talent-list">
            <li v-for="talent in tagTalent" :key="talent.id">
              <div class="flex-row">
                <div class="col-xs-6">
                  <p>{{ talent.name }}</p>
                </div>
                <div class="col-xs-6" style="text-align: right">
                  <ladda-button
                    class="btn circle-btn btn-danger-outline inactive"
                    :click="handleRemoveTalentFromTagCallback"
                    :arguments="[talent]">
                    <i class="fa fa-trash"></i> Remove From Tag
                  </ladda-button>
                </div>
              </div>
            </li>
          </ul>
          <system-tag-management-single-pagination :pagination="pagination"  @changePage="handleUpdatePagination"/>
          <div v-if="!tagTalent || !tagTalent.length" class="panel panel-default">
            <div class="panel-body">
              No {{ $starLabelPlural }} currently assigned to this tag.
            </div>
          </div>
        </div>
        <div class="text-center" v-else>
          <i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw text-muted"></i>
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>

    <system-add-talent-tag-modal :tag="tag" @addTagTalent="addTagTalent" @removeTagTalent="removeTagTalent" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { notify, http } from 'utils'
import Tags from 'components/misc/Tags'
import SystemTagManagement from './SystemTagManagement'
import SystemTagManagementSinglePagination from './SystemTagManagementSinglePagination'
import SystemAddTalentTagModal from './SystemTagManagementAddTalentModal'
import { map, cloneDeep, findIndex } from 'lodash'
import Selectize from '../ext/codium/CodiumSelectize'

export default {
  props: ['id', 'tagType'],

  data () {
    return {
      synonym: '',
      fetchingTags: false,
      addTalent: false,
      tagTalent: [],
      pagination: {},
      tag: {},
      region: null,
      regionOptions: [],
      translation: '',
      fetching: false
    }
  },

  components: {
    SystemTagManagement,
    SystemAddTalentTagModal,
    Tags,
    SystemTagManagementSinglePagination,
    Selectize
  },

  created () {
    this.getTag()
    this.getTagTalent()
    this.getRegions()
      .then((response) => {
        this.regionOptions = map(response.data, region => ({ id: region.shortname, text: region.name }))
      })
  },

  computed: {
    filteredRegionsOptions () {
      let alreadyUsed = []
      if (this.tag.translations) {
        alreadyUsed = Object.keys(this.tag.translations)
      }

      return this.regionOptions.filter(element => !alreadyUsed.includes(element.id))
    },
    currentPage () {
      return this.pagination.current_page
    }
  },

  methods: {
    ...mapActions('tag', ['saveAssociatedTags']),
    ...mapActions('region', ['getRegions']),

    getTag () {
      let apiUrl = `tag/${this.$route.params.id}`
      if (this.tagType === 'interest-categories' || this.tagType === 'personal-interests') {
        apiUrl = `${this.tagType}/${this.$route.params.id}`
      }
      return http.get(apiUrl).then(response => {
        this.tag = response.data
      }).catch((error) => {
        if (error.response && error.response.status === 404) {
          notify.error('Could not find the tag.')
        }
      })
    },

    toggleAddTalent () {
      this.addTalent = true
    },

    /**
     * Handle saving associated tags against a tag.
     *
     * @return Promise
     */
    handleSaveTagsCallback () {
      return this.saveAssociatedTags({
        id: this.$route.params.id,
        payload: {
          tag_type: this.tag.tag_type,
          child_tags: this.tag.child_tags,
          parent_tags: this.tag.parent_tags
        }
      }).then(() => {
        notify.success('Successfully saved associated tags.')
      }).catch((errors) => {
        notify.error('Sorry something has gone wrong, please try again.')
      })
    },

    handleRemoveTalentFromTagCallback (talent) {
      return this.removeTagTalent({
        id: this.$route.params.id,
        talent
      }).then(() => {
        notify.success('Successfully removed talent from tag.')
      }).catch((errors) => {
        notify.error('Sorry something has gone wrong, please try again.')
      })
    },

    handleAddSynonymCallback () {
      const synonyms = this.tag.synonyms ? this.tag.synonyms : []
      synonyms.push(this.synonym)
      return this.updateTag({ synonyms })
        .then(this.synonym = '')
        .catch((error) => {
          if (error.response) {
            notify.error(error.response.data.message)
          }
        })
    },

    handleDeleteSynonymCallback (index) {
      const synonyms = this.tag.synonyms
      synonyms.splice(index, 1)
      return this.updateTag({ synonyms }).catch((error) => {
        if (error.response) {
          notify.error(error.response.data.message)
        }
      })
    },

    handleAddTranslationCallback () {
      let translations = !this.tag.translations || Array.isArray(this.tag.translations) ? {} : cloneDeep(this.tag.translations)
      translations[this.region] = this.translation
      return this.updateTag({ translations }).then(
        this.translation = ''
      ).catch((error) => {
        if (error.response) {
          notify.error(error.response.data.message)
        }
      })
    },

    handleDeleteTranslationCallback (key) {
      const translations = this.tag.translations
      delete translations[key]
      return this.updateTag({ translations }).then(
        this.translation = ''
      ).catch((error) => {
        if (error.response) {
          notify.error(error.response.data.message)
        }
      })
    },

    updateTag (params) {
      let api
      if (this.tagType === 'interest-categories' || this.tagType === 'personal-interests') {
        api = http.post(`${this.tagType}/${this.$route.params.id}/update`, params)
      } else {
        api = http.put(`tags/${this.$route.params.id}/update`, params)
      }
      return api.then((response) => {
        this.tag = response.data
      })
    },

    getTagTalent () {
      this.fetching = true
      return http.get(`tag/${this.$route.params.id}/talent`, { params: { page: 1, tag_type: this.tagType } }).then((response) => {
        this.tagTalent = response.data.data
        this.pagination = response.data.meta
        this.fetching = false
      })
    },

    handleUpdatePagination (value) {
      this.fetching = true
      return http.get(`tag/${this.$route.params.id}/talent`, { params: { ...this.params, page: value, tag_type: this.tagType } }).then(response => {
        this.tagTalent = response.data.data
        this.pagination = response.data.meta
        this.fetching = false
      })
    },

    addTagTalent (talent) {
      return http.put(`tag/${this.$route.params.id}/add/${talent.id}`, { tag_type: this.tagType }).then(() => {
        this.getTagTalent()
      })
    },

    removeTagTalent (tagTalent) {
      const index = findIndex(this.tagTalent, element => {
        return element.id === tagTalent.talent.id
      })
      if (index !== -1) {
        return http.delete(`tag/${this.$route.params.id}/remove/${tagTalent.talent.id}`, {params: {tag_type: this.tagType}}).then(() => {
          this.tagTalent.splice(index, 1)
        })
      }
      return Promise.reject(new Error('Talent not found.'))
    }
  }
}
</script>
